<template>
  <div class="DListClassify">
    <div class="classify-list">
      <a
        v-for="(vo,idx) in classifyList"
        :key="vo.id"
        class="classify-item"
        :class="{ 'ON': vo.id == classifyId }"
        @mouseover="classifyHover(vo)"
        :href="PAGE_PATH.BASE_URL + PAGE_PATH.TU_PIAN.LIST + '/0-4-0-0-'+ vo.pid +'-'+ vo.id +'-0-default-1.html' "
        target="_blank"
      >
        {{ vo.name }}
      </a>
    </div>
  </div>
</template>

<script>
import {PAGE_PATH} from '@/constant/PAGE_PATH'

export default {
  name: "DListClassify",
  props: {
    classifyList: {
      type: Array,
      default: () => []
    },
    classifyId: {
      type: Number | String,
      default: () => 0
    }
  },
  data() {
    return {
      PAGE_PATH
    }
  },
  methods: {
    classifyHover(vo) {
      this.$emit('classifyHover', vo)
    }
  }
}
</script>

<style lang="scss" scoped>
.DListClassify {
  margin-top: 6px;

  .classify-list {
    display: flex;

    .classify-item {
      font-size: 16px;
      color: #57555C;
      line-height: 21px;
      margin-right: 24px;
      cursor: pointer;

      &:last-child {
        margin-right: 0;
      }

      &.ON {
        color: #FF791A;
      }
    }
  }
}

</style>
